import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type SuggestedMovesCurrentBoardFragment = (
  { __typename: 'Board' }
  & Pick<Types.Board, 'id'>
  & { lists: Array<(
    { __typename: 'List' }
    & Pick<Types.List, 'id' | 'name' | 'pos'>
  )>, memberships: Array<(
    { __typename: 'Board_Membership' }
    & Pick<Types.Board_Membership, 'id' | 'idMember' | 'memberType'>
  )> }
);

export const SuggestedMovesCurrentBoardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SuggestedMovesCurrentBoard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lists' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'EnumValue', value: 'open' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pos' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'memberships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'idMember' } },
                { kind: 'Field', name: { kind: 'Name', value: 'memberType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseSuggestedMovesCurrentBoardFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      SuggestedMovesCurrentBoardFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseSuggestedMovesCurrentBoardFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<SuggestedMovesCurrentBoardFragment>,
    'data'
  > {
  data?: SuggestedMovesCurrentBoardFragment;
}

export const useSuggestedMovesCurrentBoardFragment = ({
  from,
  returnPartialData,
  ...options
}: UseSuggestedMovesCurrentBoardFragmentOptions): UseSuggestedMovesCurrentBoardFragmentResult => {
  const result = Apollo.useFragment<SuggestedMovesCurrentBoardFragment>({
    ...options,
    fragment: SuggestedMovesCurrentBoardFragmentDoc,
    fragmentName: 'SuggestedMovesCurrentBoard',
    from: {
      __typename: 'Board',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as SuggestedMovesCurrentBoardFragment };
};
